import React, {
  useEffect, useLayoutEffect, useRef, useState,
} from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  useLocation, useNavigate, useParams,
} from 'react-router-dom';
import { AiFillDelete } from 'react-icons/ai';
import styles from './event.module.scss';
import { ErrorField, InputText, TextEditor } from '../../lib/HooksFormFields';
import {
  getEvent, createEvent, deleteEvent, updateEvent,
} from '../../actions/events';
import InputNumber from '../../lib/HooksFormFields/InputNumber';

const Event = () => {
  const { id } = useParams();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSaved, setIsSaved] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { event, events } = useSelector((store: any) => store).eventsReducer;

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, isDirty },
  } = useForm<FieldValues>({
    defaultValues: {
      isPublished: false,
      position: events?.length ? events.length + 1 : 1,
    },
  });

  // Navigate to page when create
  useEffect(() => {
    if (!id && event?._id && /create/.test(location.pathname)) {
      navigate(`/event/${event._id}`);
    }
  }, [event?._id]);

  async function handleDelete() {
    // eslint-disable-next-line no-alert
    if (window.confirm('Veuillez confirmer la suppression du témoignage')) {
      await deleteEvent(dispatch, event);
    }
    navigate('/event');
  }

  function onSubmit(values: FieldValues) {
    if (event?._id) {
      return updateEvent(dispatch, values);
    }
    const data = { ...values };
    return createEvent(dispatch, data);
  }

  useLayoutEffect(() => {
    containerRef?.current?.parentElement?.scrollTo({
      top: 0,
    });
  }, []);

  useEffect(() => {
    if (id) {
      getEvent(dispatch, id);
    }
  }, [id]);

  useEffect(() => {
    if (event?._id) {
      reset(event);
      setIsSaved(true);
    } else {
      reset({
        isPublished: false,
      });
    }
  }, [event]);

  useEffect(() => {
    setIsSaved(!isDirty);
  }, [isDirty]);

  return (
    <div
      id='page'
      className={styles.event}
      ref={containerRef}
    >

      <div className={styles.header}>
        <h1>{event?.name || 'Nouvel événement'}</h1>
      </div>

      <div className={styles.submit}>
        <button className={`${styles.btn} ${!watch('isPublished') ? styles.draft : styles.success}`}
          onClick={() => setValue('isPublished', !watch('isPublished'))}
        >
          {!watch('isPublished') ? 'Brouillon' : 'Publié'}
        </button>
        <button className={`${styles.btn} ${isSaved ? styles.saved : ''}`} onClick={handleSubmit(onSubmit)}>
          Sauvegarder
        </button>
      </div>
      <div className={styles.form}>
        <div className={styles.content}>
          <div className={styles.field}>
            <InputText
              label={'Nom'}
              placeholder={'Nom'}
              name={'name'}
              control={control}
              rules={{ required: 'Ce champs est requis' }}
            />
            {typeof errors?.name?.message === 'string' && <ErrorField message={errors.name.message}/>}
          </div>
          <div className={styles.field}>
            <TextEditor
              label={'Texte'}
              placeholder={''}
              name={'content'}
              control={control}
              rules={{ required: 'Ce champs est requis' }}
              maxlength={500}
              defaultValue={event?.content || ''}
            />
            {typeof errors?.content?.message === 'string' && <ErrorField message={errors.content.message}/>}
          </div>
        </div>
        <div className={styles.meta}>
          <div className={styles.field}>
            <InputNumber
              label={'Position'}
              name={'position'}
              control={control}
              rules={{ required: 'Ce champs est requis' }}
            />
            {typeof errors?.position?.message === 'string' && <ErrorField message={errors.position.message}/>}
          </div>
          {event?._id
            && <button
              className={styles.delete}
              onClick={() => handleDelete()}
            >
              <AiFillDelete />Supprimer
            </button>
          }
        </div>
      </div>
    </div>
  );
};

export default Event;
